import Titles from '../components/Titles/Titles';
import PrivacyTermsComponent from '../components/PrivacyTerms/PrivacyTermsComponent';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const PrivacyPolicyPopup = () => {
    const seo = usePageSEO('privacyPolicyPopup');

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
                type={seo.type}
                noIndex={seo.noIndex}
                noFollow={seo.noFollow}
            />
            <div className="privacy-policy-popup">
                <div className="privacy-policy-popup__container">
                    <Titles pageType="privacy" additionalElementClassName="privacy__date"/>
                    <PrivacyTermsComponent type="privacy" />
                </div>
            </div>
        </>
    );
};

export default PrivacyPolicyPopup;